import PlatformEngagement from '../platform-engagement';
import type { HeroDetailTemplateProps } from './types';
import './default-template.css';

export default function DefaultHeroDetailTemplate({
  game,
  hero,
}: HeroDetailTemplateProps) {
  return (
    <main className="default-hero-detail">
      <header>
        <a href={`/${game.domain}/dcatalog`}>← 返回{game.name}图鉴</a>
        <a href={`/${game.domain}`}>GAME WIKI</a>
      </header>
      <section className="default-hero-cover">
        <div>{hero.head && <img src={hero.head} alt="" />}</div>
        <article>
          <p>{game.name} · CHARACTER ARCHIVE</p>
          <h1>{hero.name}</h1>
          {hero.subtitle && <h2>{hero.subtitle}</h2>}
          {hero.story && <span>{hero.story}</span>}
        </article>
      </section>
      <section className="default-hero-content">
        {hero.traits.length > 0 && (
          <article>
            <h2>角色信息</h2>
            <div className="default-hero-traits">
              {hero.traits.map((item) => (
                <span key={`${item.label}:${item.name}`}>
                  {item.icon && <img src={item.icon} alt="" />}
                  <small>{item.label}</small>
                  <b>{item.name}</b>
                </span>
              ))}
            </div>
          </article>
        )}
        {hero.skills.length > 0 && (
          <article>
            <h2>技能</h2>
            <div className="default-hero-skills">
              {hero.skills.map((skill) => (
                <section key={skill.id}>
                  {skill.icon && <img src={skill.icon} alt="" />}
                  <div>
                    <small>{skill.type}</small>
                    <h3>{skill.name}</h3>
                    <p>{skill.ranks[0] || '暂无技能说明'}</p>
                  </div>
                </section>
              ))}
            </div>
          </article>
        )}
        {hero.quotes.length > 0 && (
          <article>
            <h2>角色语音</h2>
            {hero.quotes.map((quote) => (
              <blockquote key={quote}>{quote}</blockquote>
            ))}
          </article>
        )}
      </section>
      <PlatformEngagement
        linkUrl={`/${game.key}/t${hero.id}`}
        subject="英雄"
        title={hero.name}
      />
    </main>
  );
}
